import { DataManager, ODataV4Adaptor, Query } from '@syncfusion/ej2-data';

class CustomAdaptor extends ODataV4Adaptor {}

const dataManager = new DataManager({
  url: '/api/calendar-items',
  adaptor: new CustomAdaptor(),
  crossDomain: true,
});

export default dataManager;
